import { WidgetPanelDetailProps } from 'widgets/supportVisualisation/Content/Widgets/WidgetPanel';
import React, { useEffect, useState } from 'react';
import { createSymbolEventsWidgetRequestUid } from 'widgets/corpActions/store/data/SymbolEventsRequestHelpers';

import './WidgetPanelCorporateActions.scss';
import { selectCorporateActionsRequestState } from 'widgets/corpActions/store/data/selectors';
import { WidgetPanelGrid } from 'widgets/supportVisualisation/Content/Widgets/WidgetPanelGrid';
import { corporateActionsColumnDefinitions } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { useServices } from 'app/hooks';
import { SymbolEventsResponse } from 'widgets/corpActions/api/SymbolEventsResponse';

export function WidgetPanelCorporateActions(props: WidgetPanelDetailProps) {
    const {
        state,
        widget: { type: widgetType, id: widgetKey },
    } = props;
    const services = useServices();

    const [widgetData, setWidgetData] = useState<
        SymbolEventsResponse | undefined
    >(undefined);

    useEffect(() => {
        createSymbolEventsWidgetRequestUid(state.state, services, {
            widgetKey,
            widgetType,
        }).then((streamKey) => {
            if (streamKey) {
                setWidgetData(
                    selectCorporateActionsRequestState(state.state, streamKey)
                );
            }
        });
    }, [state.state, services, widgetType, widgetKey, setWidgetData]);

    if (!widgetData) {
        return (
            <div className="widget-panel widget-corporate-actions">
                No events in state
            </div>
        );
    }
    const events = widgetData.events;

    return (
        <div className="widget-panel widget-corporate-actions">
            <div className="events">
                <WidgetPanelGrid
                    key="stream"
                    data={events}
                    getRowDataId={(d) => d.uuid}
                    csvFileName={`${widgetKey}-stream`}
                    colDefs={corporateActionsColumnDefinitions}
                />
            </div>
        </div>
    );
}
